@if (blogs()?.length > 0) {
    <div class="blogs-list">
        @for (blog of blogs(); track blog) {
            <blog-card [direction]="cardDirection()" [item]="blog"></blog-card>
        }
    </div>
}
